import {windowWidth} from "../common";

let checkFlag = 0;

const _onAddressClick = (e) => {
    let oneAdr = $(e.currentTarget);
    let oneOffset = $(oneAdr).position().top;
    const mapController = $('#contacts_page .right_side_map .map');
    if (oneAdr.hasClass('active')) {
        e.stopPropagation();
    } else {
        $('#contacts_page .left_side_list .body_list .one_address').removeClass('active');
        oneAdr.addClass('active');
        //map switcher
        for (let i = 0; i < mapController.length; i++) {
            let contentAttr = $(mapController[i]);
            if (oneAdr.attr("data-value") === $(contentAttr).attr("data-value")) {
                $(contentAttr).addClass("enabled");
                $(contentAttr).removeClass("disabled");
            } else {
                $(contentAttr).addClass("disabled");
                $(contentAttr).removeClass("enabled");
            }
        }
        // scroll to center on click
        let getScroll = (oneOffset - ($(".body_list").height() / 2)) + oneAdr.parent().scrollTop() + (oneAdr.height() / 2);
        oneAdr.parent().animate({scrollTop: getScroll}, 500);
        window.location.hash = '#' + oneAdr.attr('id');
        checkFlag = 1;
    }
};

export const contactScripts = () => {
    if  ($('#contacts_page').length > 0 && windowWidth > 768) {
        $(".owl-carousel").owlCarousel({
            loop: true,
            nav: true,
            navText: ['', ''],
            navElement: 'div',
            dots: false,
            items: 1,
            autoplay: true,
            startPosition: 0,
            autoplayTimeout: 7000,
            smartSpeed: 2000,
            onTranslate : () => {
                $('.bottom_paggination hr').width('0%');
                $('.bottom_paggination hr').animate({width: '100%'}, 2000);
            }

        });
    }
    if ($('#contacts_page').length > 0) {
        if (window.location.search.length !== 0) window.location.href = window.location.href.replace(window.location.search, '');
        $(document).on('click', '#contacts_page .left_side_list .body_list .one_address', _onAddressClick);
    }
};